
import React from 'react';
import Layout from '@/components/Layout/Layout';
import InvestmentCalculator from '@/components/SpecialCalculators/FinancialCalculators/InvestmentCalculator';
import { Link } from 'react-router-dom';

const InvestmentCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4">
        {/* Header Section */}
        <div className="mb-8">
          <div className="text-sm text-gray-500 mb-2">
            <Link to="/" className="hover:underline">Home</Link> {' > '} 
            <Link to="/special" className="hover:underline">Special Tools</Link> {' > '} 
            <span>Investment Calculator</span>
          </div>
          <h1 className="text-3xl font-bold mb-3">Investment Calculator</h1>
          <p className="text-gray-700">
            Calculate potential investment growth, understand the power of compound interest, and plan your investment strategy.
          </p>
        </div>

        {/* Calculator Section */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-8">
          <InvestmentCalculator />
        </div>

        {/* Information Section */}
        <div className="bg-[#E6F3FF] p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-semibold mb-3">How to use the Investment Calculator</h2>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-2">
            <li>Enter your initial investment amount</li>
            <li>Specify your regular contribution amount and frequency</li>
            <li>Enter your expected annual interest rate</li>
            <li>Set the investment period in years</li>
            <li>Choose the compounding frequency</li>
            <li>The calculator will show your future value, total contributions, and interest earned</li>
          </ol>
        </div>

        {/* Additional Information */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">About Investment Growth</h2>
          <p className="text-gray-700 mb-3">
            Investment growth is driven by compound interest, which is the process of earning interest on both your principal 
            investment and on previously accumulated interest. This creates a snowball effect that accelerates wealth building 
            over time.
          </p>
          <p className="text-gray-700 mb-3">
            The frequency of compounding affects how quickly your investment grows. More frequent compounding (daily vs. annually) 
            results in slightly higher returns over time, though the difference is usually small for typical investment scenarios.
          </p>
          <p className="text-gray-700 mb-3">
            While this calculator provides projections based on a fixed rate of return, actual investment performance will vary 
            and may be affected by market fluctuations, inflation, taxes, and investment fees. It's always advisable to consult 
            with a financial advisor for personalized investment advice.
          </p>
        </div>

        {/* Related Calculators */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">Related Calculators</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Link to="/special/retirement" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">👴</span> Retirement Calculator
            </Link>
            <Link to="/special/interest" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💲</span> Interest Calculator
            </Link>
            <Link to="/special/loan" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💰</span> Loan Calculator
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default InvestmentCalculatorPage;
